import { useEffect, useState } from "react";
import { fetchConfig, fetchDefaultPlays } from "@/lib/api";
import { classifyHit, resolvePlayers } from "@/lib/geometry";
import { PlayField } from "@/components/field/PlayField";
import { readyPositions } from "@/components/PlaybookView";

const SCRIPT = [
  { outs: 0, runners: 1, hitType: "ground", tap: [-20, 88] },
  { outs: 1, runners: 2, hitType: "ground", tap: [80, 140] },
  { outs: 0, runners: 4, hitType: "fly", tap: [0, 165] },
  { outs: 0, runners: 3, hitType: "bunt", tap: [-15, 20] },
  { outs: 1, runners: 7, hitType: "ground", tap: [18, 92] },
];

export const LandingDemo = () => {
  const [cfg, setCfg] = useState(null);
  const [steps, setSteps] = useState([]);
  const [state, setState] = useState({ i: 0, n: 0, primed: true });

  useEffect(() => {
    fetchConfig().then(async (config) => {
      const c = config.sports.baseball.ll;
      const loaded = await Promise.all(SCRIPT.map(async (s) => {
        const hit = classifyHit(s.tap, c, s.hitType);
        const list = await fetchDefaultPlays("baseball", "ll", s);
        return { ...s, ...hit, play: list.find((p) => p.fielder === hit.fielder) };
      }));
      setCfg(c);
      setSteps(loaded.filter((s) => s.play));
    });
  }, []);

  useEffect(() => {
    if (!steps.length) return undefined;
    let idx = 0;
    let t2;
    const tick = () => {
      setState((s) => ({ ...s, primed: true }));
      t2 = setTimeout(() => {
        setState((s) => ({ i: idx, n: s.n + 1, primed: false }));
        idx = (idx + 1) % steps.length;
      }, 900);
    };
    tick();
    const t = setInterval(tick, 4600);
    return () => { clearInterval(t); clearTimeout(t2); };
  }, [steps]);

  if (!cfg || !steps.length) return <div className="field-frame aspect-[1.44/1.19] animate-pulse" data-testid="landing-demo-loading" />;
  const step = steps[state.i];
  const positions = state.primed ? readyPositions(cfg) : resolvePlayers(step.play, step.ball, cfg);
  return (
    <div className="space-y-3" data-testid="landing-demo">
      <div className="field-frame pointer-events-none">
        <PlayField cfg={cfg} runners={step.runners} positions={positions} throws={step.play.throws} runnerPaths={step.play.runner_paths}
          hit={state.primed ? null : { id: state.n, ball: step.ball, hitType: step.hitType, foul: false }} playId={`demo-${state.n}`} />
      </div>
      <p className="card !py-3 font-semibold min-h-[4.5rem]" data-testid="landing-demo-caption">{state.primed ? "Next play..." : step.play.explanation}</p>
    </div>
  );
};
